import { render, staticRenderFns } from "./ClientsFilter.vue?vue&type=template&id=7fa16dab&"
import script from "./ClientsFilter.vue?vue&type=script&lang=js&"
export * from "./ClientsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports